module.exports = __webpack_public_path__ + "img/ocean-protocol.9e3369fb.svg";